import React from "react";
import UserList from "../components/UserList";

const AllUsersPage = () => {
  return (
    <div className="container">
      <h2 className="my-4 text-center">All Users</h2>
      <UserList />
    </div>
  );
};

export default AllUsersPage;
